module.exports = __webpack_public_path__ + "img/main.779c70d8.png";